import { render } from "./Multiselect.vue?vue&type=template&id=d519b88a"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__